export const BOOKMARK_TYPE = "bookmark"
export const BOOKMARK_TYPE_TAG_VALUE = "note"
export const SENTIMENT_TYPE = "sentiment"
export const BOOKMARK_COOKIE_REMOVE = "ins_bypass_bookmark"
